import React from "react";
import { Typography } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Tooltip from "@material-ui/core/Tooltip";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  tagContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  tag: {
    padding: theme.spacing(1, 2.5),
    borderRadius: 30,
    backgroundColor: "#D6D2F7",
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    textOverflow: "ellipsis",
    maxWidth: 200,
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  removedTag: {
    opacity: 0.3,
  },
}));

const TagListComponent = ({ tagList, displayField, displayedList }) => {
  const classes = useStyles();

  const isTagRemoved = (id) => {
    if (!displayedList?.length) {
      return false;
    }

    const tag = tagList.find((t) => t.id === id);

    const is = displayedList.includes(tag);
    return !is;
  };

  return (
    <div className={classes.tagContainer}>
      {!!tagList?.length &&
        tagList.map((item) => (
          <Tooltip title={item[displayField]} key={item.id}>
            <Typography
              className={clsx(classes.tag, isTagRemoved(item.id) ? classes.removedTag : "")}
              variant={"body2"}
            >
              {item[displayField]}
            </Typography>
          </Tooltip>
        ))}
    </div>
  );
};

export default TagListComponent;
